// extracted by mini-css-extract-plugin
export default {"sub_title":"WaterUseConfig_sub_title__y42mj","sub_title_text":"WaterUseConfig_sub_title_text__nq9m3","label_empty":"WaterUseConfig_label_empty__3Qfs7"};